<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <div class="app-page-content" custom-content>
    <div class="tw-m-2 tw-flex xl:tw-flex-row tw-flex-col">
      <div
        class="tw-flex tw-flex-col xl:tw-w-1/2 xl:tw-order-1 tw-order-2 tw-w-full tw-h-full tw-mx-2"
      >
        <div class="xl:tw-order-1 tw-order-2">
          <!--selected day info-->
          <app-day-info
            [dayInfo]="selectedDayInfo"
            [isLoading]="isCalenderLoading"
          ></app-day-info>

          <!--events-->
          <app-events
            [isLoading]="isCalenderLoading"
            [pageVocabs]="pageVocabs"
            [userOrganizationId]="permissionService.userState()?.organizationId"
            [dayInfo]="selectedDayInfo"
            [isModalMode]="input_isModalMode"
            [eventType]="input_eventType"
            (selectedEventInfo)="openSelectedEventInfo($event)"
            (createModel)="onCreate($event, true)"
            (editModel)="onEditCalendarEventModal($event)"
            (deleteModel)="
              onDelete($event?.id, $event?.title); deleteEventMode = $event.type
            "
            (selectedCalendarEvent)="onSelectCalendarEvent($event)"
            (selectedCalenderOrganizationEvents)="
              onSelectCalenderOrganizationEvents($event)
            "
          ></app-events>
        </div>

        <!-- calender Event Categories -->
        <div
          class="xl:tw-order-2 tw-order-1 tw-flex tw-flex-col tw-bg-white dark:tw-bg-dark-500 tw-rounded-xl tw-mt-5 tw-h-[120px] border xl:tw-mb-0 tw-mb-3"
        >
          <!-- header -->
          <div
            class="border-bottom tw-text-lg tw-font-semibold tw-py-3 border-bottom tw-text-primary-400 tw-px-4"
          >
            <p class="dark:tw-text-primary-400">
              {{ pageVocabs + "form.filterTitle" | translate }}
            </p>
          </div>

          <!-- check box -->
          <div
            *ngIf="!isCalenderLoading"
            class="tw-grid tw-grid-cols-3 tw-gap-3 tw-mt-3"
          >
            <div *ngFor="let category of calenderEventCategories">
              <div class="form-check tw-flex tw-items-center">
                <input
                  type="checkbox"
                  [calendarEventCategories]="{
                    id: category?.id,
                    isChecked: temporarySelections[category?.id]
                  }"
                  [checked]="temporarySelections[category?.id]"
                  (click)="changeEventCategory(category)"
                />
                <label
                  class="tw-text-base tw-font-medium tw-text-gray-600 dark:tw-text-gray-300"
                  >{{ category?.name }}</label
                >
              </div>
            </div>
          </div>

          <!-- pre loading -->
          <div
            *ngIf="isCalenderLoading"
            class="tw-grid tw-grid-cols-3 tw-gap-x-5 tw-mt-3 tw-mx-3 tw-gap-y-3"
          >
            <div
              class="bg-preloading tw-w-full tw-rounded-[3px] tw-h-[20px]"
            ></div>
            <div
              class="bg-preloading tw-w-full tw-rounded-[3px] tw-h-[20px]"
            ></div>
            <div
              class="bg-preloading tw-w-full tw-rounded-[3px] tw-h-[20px]"
            ></div>
            <div
              class="bg-preloading tw-w-full tw-rounded-[3px] tw-h-[20px]"
            ></div>
            <div
              class="bg-preloading tw-w-full tw-rounded-[3px] tw-h-[20px]"
            ></div>
            <div
              class="bg-preloading tw-w-full tw-rounded-[3px] tw-h-[20px]"
            ></div>
          </div>
        </div>
      </div>

      <!-- calendar -->
      <div
        class="xl:tw-w-1/2 xl:tw-order-2 tw-order-1 tw-w-full tw-h-full tw-mr-2"
      >
        <app-calender
          [getCalenderDataFromServer]="true"
          [daySelectable]="false"
          (dayInfo)="selectedDayInfo = $event"
          [isGetCalender]="isGetCalender"
          (calenderLoading)="calenderLoading($event)"
          (isGetCalender)="isGetCalender = $event"
        ></app-calender>
      </div>
    </div>
  </div>
</app-page-template>
<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="'Calendar'"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
